import React, { useEffect } from 'react';
import RecruiterCandidatesContainer2 from 'src/components/recruiterPositions/RecruiterCandidatesContainer2';
import Container from 'src/components/shared/Container';
import { useShepherdTour, ShepherdOptionsWithType } from 'react-shepherd';
import { useGetPositionByIdQuery } from 'src/hooks/position.hooks';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { completeGuidedTour } from 'src/apis/position';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { isUserRecruiter } from 'shared-utils';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
// import 'react-shepherd/shepherd.css';
const RecruiterCandidatesPage = () => {
	const { user } = useUserContext();
	const { positionId } = useParams();
	const navigate = useNavigate();

	const { data: position, refetch: refetchPosition } = useGetPositionByIdQuery(positionId);

	const location = useLocation();
	const beforeShowPromise = function () {
		return new Promise(function (resolve) {
			// wait till walkthrough-first-element is visible
			const interval = setInterval(function () {
				const element = document.querySelector('.walkthrough-first-element');
				if (element) {
					clearInterval(interval);
					resolve(() => {
						//
					});
				}
			}, 500);
		});
	};
	const toast = useToast();
	/* ------------------------------------- tour flow start ------------------------------------- */
	const { positions } = useRecommendationsContext();

	const [isTourShownAlreadyShownForOnePosition, setIsTourShownAlreadyShownForOnePosition] = React.useState<
		boolean | undefined
	>(undefined);

	useEffect(() => {
		positions.map(position => {
			return position.position.showGuidedTour === false && setIsTourShownAlreadyShownForOnePosition(true);
		});
	}, [positions]);

	const [isTourActive, setIsTourActive] = React.useState<boolean | undefined>(undefined);
	const [isTourDoneOnce, setIsTourDoneOnce] = React.useState<boolean | undefined>(undefined);

	const tourOptions = {
		defaultStepOptions: {
			cancelIcon: {
				enabled: false,
			},
		},
		useModalOverlay: true,
	};
	const steps: ShepherdOptionsWithType[] = [
		{
			id: 'recommendations',
			attachTo: {
				element: '.walkthrough-first-element',
				on: 'bottom',
			},
			beforeShowPromise,
			buttons: [
				{
					classes: 'shepherd-button-exit',
					type: 'cancel',
				},
				{
					classes: 'shepherd-button-back-first',
					type: 'back',
				},
				{
					classes: 'shepherd-button-next',
					type: 'next',
					text: 'Next',
				},
			],
			text: ['Here, you will find a list of all recommended candidates who match your job requirements!'],
		},
		{
			id: 'applicants',
			attachTo: {
				element: '.walkthrough-second-element',
				on: 'bottom',
			},
			// beforeShowPromise,
			buttons: [
				{
					classes: 'shepherd-button-exit',

					type: 'cancel',
				},
				{
					classes: 'shepherd-button-back-first',

					type: 'back',
				},
				{
					classes: 'shepherd-button-next',
					type: 'next',
					text: 'Next',
				},
			],
			text: ['In the Applicants tab, find all candidates who have shown interest in your job posting.'],
		},
		{
			id: 'filter',
			attachTo: {
				element: '.walkthrough-third-element',
				on: 'bottom',
			},
			// beforeShowPromise,
			buttons: [
				{
					classes: 'shepherd-button-exit',

					type: 'cancel',
				},
				{
					classes: 'shepherd-button-back-first',

					type: 'back',
				},
				{
					classes: 'shepherd-button-next',
					text: 'Next',
					type: 'next',
				},
			],
			text: ['Use various filters to refine your search for the ideal candidate.'],
		},
		{
			id: 'bulk-actions',
			attachTo: {
				element: '.walkthrough-fourth-element',
				on: 'bottom',
			},
			// beforeShowPromise,
			buttons: [
				{
					classes: 'shepherd-button-exit',
					type: 'cancel',
				},
				{
					classes: 'shepherd-button-back-first',
					type: 'back',
				},
				{
					classes: 'shepherd-button-next',
					text: 'Ok',
					type: 'next',
				},
			],
			text: [
				'The multi-select feature enables you to simultaneously share multiple candidate profiles with your peers and streamline interview scheduling.',
			],
		},
	];
	const tour = useShepherdTour({ tourOptions, steps: steps });
	const completeGuidedTourMutation = useMutation(['completeGuidedTour'], completeGuidedTour, {
		onSuccess() {
			refetchPosition();
			tour.cancel();
			setIsTourDoneOnce(true);
		},
		onError(error: Error) {
			toast({
				title: `Error occured while completing guided tour: ${error.message}`,
				type: 'error',
			});
		},
	});
	const [isFirstTourElementVisible, setIsFirstTourElementVisible] = React.useState<boolean | undefined>(undefined);
	useEffect(() => {
		const interval = setInterval(() => {
			const element = document.querySelector('.walkthrough-first-element');
			if (element && position?.position?.showGuidedTour === true && position?.position?.isPublished === true) {
				setIsFirstTourElementVisible(true);
				clearInterval(interval);
			}
		}, 500);

		return () => clearInterval(interval);
	}, [position?.position?.isPublished, position?.position?.showGuidedTour]);

	useEffect(() => {
		if (!position || !position?.position || !position?.position?.isPublished) {
			tour.cancel();
			return;
		}
		const showTour =
			user?.role &&
			position?.position &&
			position?.position?.isPublished &&
			!isTourShownAlreadyShownForOnePosition &&
			isUserRecruiter(user?.role) &&
			position?.position?.showGuidedTour === true &&
			!tour.isActive() &&
			!isTourActive &&
			isFirstTourElementVisible === true &&
			!isTourDoneOnce &&
			!location.pathname.includes('pipeline');

		if (showTour) {
			console.log('hello showTour is enabled', isFirstTourElementVisible);
			tour.start();
		} else {
			tour.cancel();
			console.log('hello showTour is disabled', isFirstTourElementVisible);
		}
		return () => {
			tour.cancel();
			setIsTourActive(false);
		};
	}, [
		user?.role,
		position?.position,
		position?.position?.isPublished,
		position?.position?.showGuidedTour,
		isFirstTourElementVisible,
		isTourDoneOnce,
	]);

	tour.on('complete', () => {
		positionId && completeGuidedTourMutation.mutate({ positionId: positionId });
		setIsTourActive(false);
		setIsTourDoneOnce(true);
		// console.log('tour:-----complete');
	});

	useEffect(() => {
		if (!positionId || positionId === 'undefined') {
			// console.log('navigating');
			navigate('/');
		}
	}, [positionId]);

	// const [showScheduleInterviewDrawer, setShowScheduleInterviewDrawer] = React.useState(false);

	return (
		<>
			<Container>
				<RecruiterCandidatesContainer2 isTourActive={!!isTourActive} />
				{/* {hasCandidates ? (
				) : (
					<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
						<NoRecruiterCandidatesContainer />
					</div>
				)} */}
			</Container>
			{/* <Drawer
				minHeight="max-content"
				maxHeight="90dvh"
				boxShadow="0px -8px 32px 0px #00000040"
				isOpen={showScheduleInterviewDrawer}
				onClose={() => {
					setShowScheduleInterviewDrawer(false);
				}}
				header={<></>}
				body={
					<div className="px-3 py-4">
						<ScheduleInterview />
					</div>
				}
			/> */}
		</>
	);
};

export default RecruiterCandidatesPage;
